import { AfterViewInit, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { FfeilService } from "src/app/craidd/gwasanaethau/ffeil/ffeil.service";
import { FfeilUwchlwytho } from "src/app/craidd/modelau/ffeil/ffeil-uwchlwytho";
import { UwchlwythoFfeil } from "src/app/craidd/modelau/ui/uwchlwytho-ffeil";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { MatList, MatListItem } from "@angular/material/list";
import { MatLine } from "@angular/material/grid-list";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-uwchlwytho-ffeil",
  templateUrl: "./uwchlwytho-ffeil.component.html",
  styleUrls: ["./uwchlwytho-ffeil.component.scss"],
  imports: [MatDialogTitle, FaIconComponent, CdkScrollable, MatDialogContent, MatButton, MatList, MatListItem, MatLine, MatProgressBar, MatDialogActions, MatIcon, MatProgressSpinner, TranslatePipe],
})
export class UwchlwythoFfeilComponent implements AfterViewInit {
  ynArbed = false;

  ffeiliauInput: HTMLInputElement;

  ffeiliau: Array<FfeilUwchlwytho> = [];

  constructor(
    public dialogRef: MatDialogRef<UwchlwythoFfeilComponent>,
    private ffeilService: FfeilService,
    @Inject(MAT_DIALOG_DATA) public data: UwchlwythoFfeil,
  ) {}

  ngAfterViewInit(): void {
    this.ffeiliauInput = document.getElementById("ffeiliauInput") as HTMLInputElement;
  }

  cau(): void {
    this.dialogRef.close(true);
  }

  dewis(): void {
    this.ffeiliauInput.onchange = () => {
      for (let index = 0; index < this.ffeiliauInput.files.length; index++) {
        const file = this.ffeiliauInput.files[index];

        const reader = new FileReader();

        reader.onload = () => {
          const base64 = (reader.result as string).split(",")[1];

          this.ffeiliau.push({
            ffeil: file,
            enw: file.name,
            maint: file.size,
            math: file.type,
            data: base64,
            statws: 0,
          });
        };

        reader.readAsDataURL(file);
      }
    };

    this.ffeiliauInput.click();
  }

  dileu(ffeil: FfeilUwchlwytho): void {
    this.tynnuFfeil(ffeil);
  }

  uwchlwytho(): void {
    this.ynArbed = true;

    this.ffeiliau.forEach((ffeil) => {
      if (ffeil.statws !== 3) {
        ffeil.statws = 1;

        this.ffeilService.uwchlwytho(this.data.url, ffeil).subscribe({
          next: () => {
            this.ynArbed = false;
          },
          error: (error) => {
            this.ynArbed = false;
            ffeil.statws = 2;
            ffeil.gwall = error.errors[0];
          },
          complete: () => {
            ffeil.statws = 3;
            ffeil.gwall = undefined;
          },
        });
      }
    });
  }
  
  private tynnuFfeil(file: FfeilUwchlwytho): void {
    const index = this.ffeiliau.indexOf(file);
    if (index > -1) {
      this.ffeiliau.splice(index, 1);
    }
  }
}
